/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

export module SysteminfoTypes {

/** This object was automatically generated by json-schema-to-typescript. DO NOT MODIFY IT BY HAND. */

export interface SystemInfoRequest {
    [k: string]: any;
}
/**
 * This interface was referenced by `SystemInfoRequest`'s JSON-Schema
 * via the `definition` "SystemInfo".
 */
export interface SystemInfo {
    DeviceId?: string;
    ProductVersion?: string;
    ProductName?: string;
    Region?: string;
    CPUName?: string;
    Disk?: Disk[];
    PhysicalDisk?: PhysicalDisk[];
    Display?: Display[];
    GPU?: GPU;
    HID?: HID;
    Network?: Network;
    OSName?: string;
    OSVersion?: string;
    BrowserName?: string;
    BrowserVersion?: string;
    OSBuildNumber?: string;
    PhysicalMemoryCapacity?: string;
    Platform?: string;
    ProcessorArchitecture?: string;
    SystemName?: string;
    UserDefaultUILanguage?: string;
    VendorName?: string;
    SubApiName?: string;
    ErrorMessage?: string;
    ApiStatus?: ApiStatusEnum;
    DxVersion?: string;
    DeviceType?: string;
    ConfidenceInBrowser?: number;
    IsBrowserForged?: boolean;
    IsConnectedByVM?: IsConnectedByVm;
    Location?: boolean;
    Make?: string;
    Model?: string;
    CurrentUiMode?: UiModeEnum;
    DisplayDataInfo?: DisplayDataInfo;
    UserSpecifiedDeviceName?: string;
    /**
     * Installed container/shell version. Empty on clients that do not have a separate shell. Not a product version.
     */
    ShellVersion?: string;
    AwdlEnabled?: boolean;
}
export interface Disk {
    FreeSpace?: string;
    MediumType?: string;
    TotalSize?: string;
}
export interface PhysicalDisk {
    MediumType: string;
    TotalSize: string;
}
export interface Display {
    LogicalResolution: string;
    PhysicalResolution: string;
    RefreshRate: string;
}
export interface GPU {
    GPUData?: GpuData[];
    PrimaryGPUDriverInfo?: PrimaryGPUDriverInfo;
}
export interface GpuData {
    LongGPUName?: string;
    VDSR?: string;
}
export interface PrimaryGPUDriverInfo {
    GpuProduct?: string;
    GpuRevision?: string;
    GpuBuildNumHi?: string;
    GpuBuildNumLo?: string;
    GpuDriverName?: string;
}
export interface HID {
    Keyboard?: HidDevice[];
    Mouse?: HidDevice[];
    GamePad?: HidDevice[];
    Joystick?: HidDevice[];
}
export interface HidDevice {
    manufacturer?: string;
    productID?: string;
    reportIntervalUs?: string;
    transport?: string;
    vendorID?: string;
    versionNumber?: string;
}
export interface Network {
    Fingerprint?: string;
    GatewayIP?: string;
    IPAddress?: string;
    IsVPN?: string;
    MACAddress?: string;
    NetworkName?: string;
    NetworkType?: string;
    RouterMACAddress?: string;
}
export interface DisplayDataInfo {
    desiredContentMaxLuminance?: number;
    desiredContentMinLuminance?: number;
    desiredContentMaxFrameAverageLuminance?: number;
}
/**
 * This interface was referenced by `SystemInfoRequest`'s JSON-Schema
 * via the `definition` "BrowserInfo".
 */
export interface BrowserInfo {
    BrowserNameNative: string;
    BrowserVersionNative: string;
}
/**
 * This interface was referenced by `SystemInfoRequest`'s JSON-Schema
 * via the `definition` "DeviceIDInfo".
 */
export interface DeviceIDInfo {
    DeviceID: string;
}
/**
 * This interface was referenced by `SystemInfoRequest`'s JSON-Schema
 * via the `definition` "StreamingSupportInfo".
 */
export interface StreamingSupportInfo {
    IsStreamingSupported: boolean;
}
/**
 * This interface was referenced by `SystemInfoRequest`'s JSON-Schema
 * via the `definition` "NetworkTypeChangedInfo".
 */
export interface NetworkTypeChangedInfo {
    networkType: string;
}
/**
 * This interface was referenced by `SystemInfoRequest`'s JSON-Schema
 * via the `definition` "GetSystemInfoParameters".
 */
export interface GetSystemInfoParameters {
    keys: string[];
}
/**
 * This interface was referenced by `SystemInfoRequest`'s JSON-Schema
 * via the `definition` "GetClientHeadersInfoParameters".
 */
export interface GetClientHeadersInfoParameters {
    key?: string;
}
/**
 * This interface was referenced by `SystemInfoRequest`'s JSON-Schema
 * via the `definition` "DNSLookupParameters".
 */
export interface DNSLookupParameters {
    name: string;
}

/**
 * This interface was referenced by `SystemInfoRequest`'s JSON-Schema
 * via the `definition` "ApiStatusEnum".
 */
export enum ApiStatusEnum {
    Success = 'Success',
    Failure = 'Failure'
}
/**
 * This interface was referenced by `SystemInfoRequest`'s JSON-Schema
 * via the `definition` "UiModeEnum".
 */
export enum UiModeEnum {
    Desktop = 'Desktop',
    Mobile = 'Mobile',
    Game = 'Game'
}
/**
 * This interface was referenced by `SystemInfoRequest`'s JSON-Schema
 * via the `definition` "IsConnectedByVmEnum".
 */
export enum IsConnectedByVmEnum {
    not_vm = 'not_vm',
    vm = 'vm',
    unknown = 'unknown'
}
/**
 * Guest OS VM detection result
 */
export enum IsConnectedByVm {
    not_vm = 'not_vm',
    vm = 'vm',
    unknown = 'unknown'
}


}
